import { Injectable, Component, Input, NgModule } from '@angular/core';

/**
 * @fileoverview added by tsickle
 * Generated from: lib/aacl-icon.options.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingRequire,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
import * as ɵngcc0 from '@angular/core';
class AaclIconModuleOptions {
}
AaclIconModuleOptions.ɵfac = function AaclIconModuleOptions_Factory(t) { return new (t || AaclIconModuleOptions)(); };
AaclIconModuleOptions.ɵprov = /*@__PURE__*/ ɵngcc0.ɵɵdefineInjectable({ token: AaclIconModuleOptions, factory: AaclIconModuleOptions.ɵfac });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(AaclIconModuleOptions, [{
        type: Injectable
    }], null, null); })();
if (false) {
    /** @type {?} */
    AaclIconModuleOptions.prototype.svgPath;
}

/**
 * @fileoverview added by tsickle
 * Generated from: lib/aacl-icon.service.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingRequire,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
class AaclIconService {
    /**
     * @param {?} _aaclModuleOptions
     */
    constructor(_aaclModuleOptions) {
        this._aaclModuleOptions = _aaclModuleOptions;
        //
    }
    /**
     * @return {?}
     */
    getSvgPath() {
        return this._aaclModuleOptions.svgPath;
    }
}
AaclIconService.ɵfac = function AaclIconService_Factory(t) { return new (t || AaclIconService)(ɵngcc0.ɵɵinject(AaclIconModuleOptions)); };
AaclIconService.ɵprov = /*@__PURE__*/ ɵngcc0.ɵɵdefineInjectable({ token: AaclIconService, factory: AaclIconService.ɵfac });
/** @nocollapse */
AaclIconService.ctorParameters = () => [
    { type: AaclIconModuleOptions }
];
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(AaclIconService, [{
        type: Injectable
    }], function () { return [{ type: AaclIconModuleOptions }]; }, null); })();
if (false) {
    /**
     * @type {?}
     * @private
     */
    AaclIconService.prototype._aaclModuleOptions;
}

/**
 * @fileoverview added by tsickle
 * Generated from: lib/aacl-icon.component.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingRequire,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
class AaclIconComponent {
    /**
     * @param {?} _iconService
     */
    constructor(_iconService) {
        this._iconService = _iconService;
    }
    /**
     * @return {?}
     */
    get iconLink() {
        return `${this._iconService.getSvgPath()}${this.name}`;
    }
}
AaclIconComponent.ɵfac = function AaclIconComponent_Factory(t) { return new (t || AaclIconComponent)(ɵngcc0.ɵɵdirectiveInject(AaclIconService)); };
AaclIconComponent.ɵcmp = /*@__PURE__*/ ɵngcc0.ɵɵdefineComponent({ type: AaclIconComponent, selectors: [["aacl-icon"]], inputs: { name: "name" }, decls: 3, vars: 1, consts: [[1, "icon-wrapper"], [1, "icon"], [0, "xmlns", "xlink", "http://www.w3.org/1999/xlink", "href", ""]], template: function AaclIconComponent_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵelementStart(0, "div", 0);
        ɵngcc0.ɵɵnamespaceSVG();
        ɵngcc0.ɵɵelementStart(1, "svg", 1);
        ɵngcc0.ɵɵelement(2, "use", 2);
        ɵngcc0.ɵɵelementEnd()();
    } if (rf & 2) {
        ɵngcc0.ɵɵadvance(2);
        ɵngcc0.ɵɵattribute("href", ctx.iconLink);
    } }, styles: [".icon-wrapper[_ngcontent-%COMP%]{align-content:center;align-items:center;box-sizing:border-box;display:flex;justify-content:center;justify-items:center;margin:0!important;padding:0!important}.icon-wrapper[_ngcontent-%COMP%]   .icon[_ngcontent-%COMP%]{height:1em;margin:0;overflow:hidden;padding:0;vertical-align:middle;width:1em}"] });
/** @nocollapse */
AaclIconComponent.ctorParameters = () => [
    { type: AaclIconService }
];
AaclIconComponent.propDecorators = {
    name: [{ type: Input }]
};
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(AaclIconComponent, [{
        type: Component,
        args: [{ selector: 'aacl-icon', template: "<div class=\"icon-wrapper\">\r\n    <svg class= \"icon\">\r\n        <use xmlns:xlink = \"http://www.w3.org/1999/xlink\" href=\"\" [attr.href]=\"iconLink\"></use>\r\n    </svg>\r\n</div>\r\n", styles: [".icon-wrapper{align-content:center;align-items:center;box-sizing:border-box;display:flex;justify-content:center;justify-items:center;margin:0!important;padding:0!important}.icon-wrapper .icon{height:1em;margin:0;overflow:hidden;padding:0;vertical-align:middle;width:1em}"] }]
    }], function () { return [{ type: AaclIconService }]; }, { name: [{
            type: Input
        }] }); })();
if (false) {
    /** @type {?} */
    AaclIconComponent.prototype.name;
    /**
     * @type {?}
     * @private
     */
    AaclIconComponent.prototype._iconService;
}

/**
 * @fileoverview added by tsickle
 * Generated from: lib/aacl-icon.module.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingRequire,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
class AaclIconModule {
    /**
     * @param {?} aaclIconModuleOptions
     * @return {?}
     */
    static setSvgPath(aaclIconModuleOptions) {
        return {
            ngModule: AaclIconModule,
            providers: [
                { provide: AaclIconModuleOptions, useValue: aaclIconModuleOptions }
            ]
        };
    }
}
AaclIconModule.ɵfac = function AaclIconModule_Factory(t) { return new (t || AaclIconModule)(); };
AaclIconModule.ɵmod = /*@__PURE__*/ ɵngcc0.ɵɵdefineNgModule({ type: AaclIconModule });
AaclIconModule.ɵinj = /*@__PURE__*/ ɵngcc0.ɵɵdefineInjector({ providers: [
        AaclIconService,
        AaclIconModuleOptions
    ] });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(AaclIconModule, [{
        type: NgModule,
        args: [{
                declarations: [
                    AaclIconComponent
                ],
                imports: [],
                exports: [
                    AaclIconComponent
                ],
                providers: [
                    AaclIconService,
                    AaclIconModuleOptions
                ]
            }]
    }], null, null); })();
(function () { (typeof ngJitMode === "undefined" || ngJitMode) && ɵngcc0.ɵɵsetNgModuleScope(AaclIconModule, { declarations: [AaclIconComponent], exports: [AaclIconComponent] }); })();

/**
 * @fileoverview added by tsickle
 * Generated from: public_api.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingRequire,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */

/**
 * @fileoverview added by tsickle
 * Generated from: aacl-icon.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingRequire,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */

export { AaclIconComponent, AaclIconModule, AaclIconModuleOptions, AaclIconService };

